import { createSlice } from '@reduxjs/toolkit';
import { getAccountLicenses } from './accountLicensesAction';

export const accountLicensesSlice = createSlice({
  name: 'accountLicenses',
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAccountLicenses.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAccountLicenses.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload.licenseList;
      state.error = null;
    });
    builder.addCase(getAccountLicenses.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});
